import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { installGlobalErrorHandlers } from "@/lib/logger";
import { captureAuthLinkFromUrl } from "@/app/auth-links";
import "./index.css";

captureAuthLinkFromUrl();
installGlobalErrorHandlers();
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
